import styled from 'styled-components'

import logoImage from '@/assets/images/logos/login.logo-white.png'
import sidebarLogoImageWhite from '@/assets/images/logos/sidebar.logo-white.png'
import sidebarLogoImage from '@/assets/images/logos/sidebar.logo.png'
import { useCustomSettings } from '@/core/hooks/misc/useCustomSettings'

interface LogoProps {
	width?: string
	height?: string
}

export const Logo = ({ width = '40px', height = '40px' }: LogoProps) => {
	const { data: customSettings } = useCustomSettings()
	const logoSrc = customSettings?.images?.login_logo || logoImage

	return <LogoImg src={logoSrc} alt="Logo" $width={width} $height={height} />
}

export const LogoIcon = ({ width = '40px', height = '40px' }: LogoProps) => {
	const { data: customSettings } = useCustomSettings()
	const logoSrc = customSettings?.images?.sidebar_logo || sidebarLogoImageWhite

	return <LogoImg src={logoSrc} alt="Logo" $width={width} $height={height} />
}

export const LogoIconInverse = ({
	width = '40px',
	height = '40px',
}: LogoProps) => {
	const { data: customSettings } = useCustomSettings()
	const logoSrc = customSettings?.images?.sidebar_logo || sidebarLogoImage

	return <LogoImg src={logoSrc} alt="Logo" $width={width} $height={height} />
}

const LogoImg = styled.img<{ $width: string; $height: string }>`
	display: block;
	width: ${(p) => p.$width};
	height: ${(p) => p.$height};
	max-width: none; /* override global img { max-width: 100% } resets (e.g. Tailwind preflight) */
`
